import axios from 'axios';
import { ref, onMounted, computed, ComputedRef, reactive } from '@vue/composition-api';
import { Endpoints } from '@/ts/store/Constants';


interface ChannelImage {
    imageGuid: string;
    imageData: string | null;
}

const imageArray = ref([]);

export default function useMessageImage(imageGuid: string) {

  const image: ComputedRef<ChannelImage | null> = computed(() => imageArray.value.find((image) => {
    return image.imageGuid === imageGuid;
  }));

  const imageData: ComputedRef<string | null> = computed(() => image.value ? image.value.imageData : null);

  onMounted(async () => {
    const cachedValue = imageArray.value.find((image) => {
      return image.imageGuid === imageGuid;
    });
    
    if (!cachedValue) {
      try {
        const response = await axios.get(Endpoints.Images.IMAGE_ORIGINAL(imageGuid));
        const newImage: ChannelImage = {
          imageGuid,
          imageData: response.data.imageData,
        };
        const arrayCopy = Object.assign([], imageArray.value);
        arrayCopy.push(newImage);
        imageArray.value = arrayCopy;
      } catch (error) {
        console.log('Could not fetch image for message attachment: ' + imageGuid);
      }
    } 
  });

  return {
    imageData,
  };
}
